export default "__VITE_ASSET__BHwPY6DB__"